module.exports = __webpack_public_path__ + "slider2.jpg?c09681ef79e74ff3ca8f606d6962b680";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/slider2.jpg
// module id = 122
// module chunks = 0